<template>
  <v-card class="ai-card d-flex flex-column" flat>
    <div class="ai-card__accent" :style="{ backgroundColor: optionColor }"></div>

    <v-chip
      v-if="tag"
      small
      label
      :color="optionColor"
      class="ai-card__tag white--text font-weight-medium"
    >
      {{ tag }}
    </v-chip>

    <v-card-text class="d-flex flex-column flex-grow-1 pt-6">
      <div class="d-flex align-center mb-5">
        <v-avatar :color="optionColor" size="52" class="mr-3 ai-card__avatar">
          <v-icon color="white" size="26">{{
            optionIcon || "mdi-file-chart-outline"
          }}</v-icon>
        </v-avatar>
        <div>
          <div class="text-overline ai-card__name">{{ optionName }}</div>
          <div class="text-h5 font-weight-bold" :style="{ color: optionColor }">
            {{ optionPrice }}
          </div>
        </div>
      </div>

      <ul class="ai-card__features flex-grow-1">
        <li v-for="f in optionFeatures" :key="f">
          <v-icon size="18" :color="optionColor" class="mr-2 mt-1"
            >mdi-check-circle</v-icon
          >
          <span>{{ f }}</span>
        </li>
      </ul>

      <a
        target="_blank"
        rel="noopener noreferrer"
        :href="exampleUrl"
        class="ai-card__example text-decoration-none d-flex align-center justify-center"
      >
        See example
        <v-icon size="14" class="ml-1">mdi-open-in-new</v-icon>
      </a>

      <div class="mt-5">
        <template v-if="!userLoggedIn">
          <p class="text-caption text-center grey--text text--darken-1 mb-2">
            Available for logged-in users<span v-if="proOption">
              with PRO subscription</span
            >
          </p>
          <v-btn
            block
            rounded
            color="primary"
            class="mb-2"
            href="/login?path=evaluate-ai"
          >
            Sign in
          </v-btn>
          <v-btn block rounded text href="/register?path=evaluate-ai">
            Sign up
          </v-btn>
        </template>
        <template v-else>
          <v-btn
            v-if="proOption && !userCanUseProAi"
            block
            rounded
            color="primary"
            class="white--text mb-2"
            to="/gopro"
          >
            <v-icon left size="18">mdi-lock-outline</v-icon>
            Unlock with PRO
          </v-btn>
          <v-btn
            block
            rounded
            large
            depressed
            :color="optionColor"
            class="white--text ai-card__cta"
            @click="selectOption"
            :disabled="proOption && !userCanUseProAi"
          >
            Select
            <v-icon right size="18">mdi-arrow-right</v-icon>
          </v-btn>
        </template>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "AiPricingCard",
  props: [
    "optionName",
    "optionId",
    "optionPrice",
    "optionColor",
    "optionFeatures",
    "optionIcon",
    "tag",
    "exampleUrl",
    "proOption",
  ],
  data: () => ({
    userLoggedIn: false,
    userCanUseProAi: false,
  }),
  methods: {
    selectOption() {
      this.$emit("pricingOptionSelected", this.optionId);
    },
  },
  mounted() {
    this.userLoggedIn = this.$store.getters.userLoggedIn;
    this.userCanUseProAi = this.$store.getters.canUseProAiReviews;
  },
};
</script>

<style scoped>
.ai-card {
  position: relative;
  width: 100%;
  border-radius: 20px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 12px rgba(17, 24, 39, 0.06);
  overflow: hidden;
  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease;
}

.ai-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 32px rgba(17, 24, 39, 0.14);
}

.ai-card__accent {
  height: 6px;
  width: 100%;
}

.ai-card__tag {
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 11px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.ai-card__avatar {
  box-shadow: 0 6px 16px rgba(17, 24, 39, 0.18);
}

.ai-card__name {
  letter-spacing: 0.6px;
  color: rgba(0, 0, 0, 0.55);
  line-height: 1.2;
}

.ai-card__features {
  list-style: none;
  margin: 0 0 12px 0;
  padding: 0;
}

.ai-card__features li {
  display: flex;
  align-items: flex-start;
  padding: 6px 0;
  font-size: 0.92rem;
  line-height: 1.35;
}

.ai-card__example {
  font-size: 0.85rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
}

.ai-card__cta {
  letter-spacing: 0.3px;
}
</style>
